import React from 'react'
import { Link } from 'react-router-dom'
import { motion } from 'framer-motion'
import { clsx } from 'clsx'
import { ArrowUpIcon, ArrowDownIcon } from '@heroicons/react/20/solid'
import { Sparkline } from '../charts'

const StatCard = ({
  title,
  value,
  change,
  changeType,
  icon: Icon,
  color = 'primary',
  href,
  sparklineData,
  sparklineColor,
  delay = 0,
}) => {
  const colorMap = {
    primary: {
      iconBg: 'bg-primary-100',
      iconColor: 'text-primary-600',
    },
    success: {
      iconBg: 'bg-success-100',
      iconColor: 'text-success-600',
    },
    warning: {
      iconBg: 'bg-warning-100',
      iconColor: 'text-warning-600',
    },
    secondary: {
      iconBg: 'bg-secondary-100',
      iconColor: 'text-secondary-600',
    },
    error: {
      iconBg: 'bg-error-100',
      iconColor: 'text-error-600',
    },
  }

  const colors = colorMap[color] || colorMap.primary

  const Wrapper = href ? Link : 'div'
  const wrapperProps = href ? { to: href } : {}

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, delay }}
    >
      <Wrapper
        {...wrapperProps}
        className="block bg-[var(--color-surface)] rounded-xl border border-[var(--color-border)] p-5 hover:shadow-lg transition-all cursor-pointer group"
      >
        <div className="flex items-start justify-between">
          <div className="flex-1 min-w-0">
            <p className="text-sm font-medium text-[var(--color-text-muted)] truncate">
              {title}
            </p>
            <p className="mt-2 text-2xl font-bold text-[var(--color-text)]">
              {value}
            </p>
            {change && (
              <div className="mt-2 flex items-center gap-1.5">
                {changeType === 'increase' && (
                  <ArrowUpIcon className="h-4 w-4 text-error-500" />
                )}
                {changeType === 'decrease' && (
                  <ArrowDownIcon className="h-4 w-4 text-success-500" />
                )}
                <span
                  className={clsx(
                    'text-xs font-medium',
                    changeType === 'increase' && 'text-error-600',
                    changeType === 'decrease' && 'text-success-600',
                    !changeType && 'text-[var(--color-text-muted)]'
                  )}
                >
                  {change}
                </span>
              </div>
            )}
          </div>

          <div className="flex flex-col items-end gap-3">
            <div className={clsx('rounded-lg p-2.5', colors.iconBg)}>
              {Icon && <Icon className={clsx('h-5 w-5', colors.iconColor)} />}
            </div>
            {sparklineData && sparklineData.length > 1 && (
              <Sparkline data={sparklineData} color={sparklineColor || '#1f9f93'} />
            )}
          </div>
        </div>
      </Wrapper>
    </motion.div>
  )
}

export default StatCard
